<template>
	<v-card>
		<v-card-title>
			<v-icon
				icon="$mobile"
				start
			/>
			<translate>Telephone Number</translate>(s)
		</v-card-title>
		<v-card-text>
			<v-row
				v-for="number in numbers"
				:key="number.id"
			>
				<v-col>
					<v-text-field
						v-model="number.number"
						:label="$gettext('Number')"
						:rules="[v => !v || /^\+(?:[0-9] ?){6,14}[0-9]$/.test(v) || $gettext('Telephone number must be international format')]"
						variant="outlined"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field
						v-model="newNumber"
						:label="$gettext('Extra number')"
						:rules="[v => !v || /^\+(?:[0-9] ?){6,14}[0-9]$/.test(v) || $gettext('Telephone number must be international format')]"
						variant="outlined"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				v-can="'telephonenumber.update'"
				color="primary"
				variant="text"
				@click="submitData"
			>
				<translate>Save</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	inform, displayError,
} from 'laravel-front-library';

export default {
	name: 'UserTelephoneNumbers',

	props: {
		userId: {
			required: true,
			type: String
		},
	},

	data () {
		return {
			numbers: [],
			newNumber: '',
		};
	},

	mounted () {
		this.getTelephoneNumber();
	},

	methods: {
		/**
		 * Retrieve the telephone numbers for the current user
		 */
		getTelephoneNumber () {
			axios.get(`/api/v0/telephonenumbers?user_id=${this.userId}`)
				.then(({
					data: data
				}) => {
					this.numbers = data;
				})
				.catch((error) => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
					window.captureException(error);
				});
		},

		/**
		 * Submit the new number or updated number or the user
		 */
		submitData () {
			const sendNumbers = Object.assign([], this.numbers);
			const newNumber = {
				'number': this.newNumber
			};

			sendNumbers.push(newNumber);
			axios.post('/api/v0/telephonenumbers', {
				userId: this.userId,
				telephonenumbers: sendNumbers
			}).then(() => {
				inform(this.$gettext('Updated'));
				window.location.reload();
			}).catch((error) => {
				if (error.response.data) {
					displayError(this.$gettext(error.response.data));
				} else {
					displayError(this.$gettext('Something has gone wrong'));
					window.captureException(error);
				}
			});
		}
	}
};
</script>

